import React from 'react';
import { connect } from 'redux-bundler-react';

class Map extends React.Component {

  componentDidMount(){
    const { doCreateMap, viewState } = this.props;
    const { center, zoom, rotation, minZoom, maxZoom } = viewState;
    doCreateMap({
      center: center,
      zoom: zoom,
      rotation: rotation,
      minZoom: minZoom,
      maxZoom: maxZoom,
      layers:[],
      target: this.mapEl
    })
  }

  render(){
    const { cursorClass } = this.props;
    return (
      <div id="map" className={cursorClass} ref={(el) => { this.mapEl = el }}/>
    )
  }
}

export default connect(
  'doCreateMap',
  'selectViewState',
  'selectCursorClass',
  Map
);